import { useEffect } from 'react';

/**
 * Hook to listen for file_updated WebSocket events.
 * Each consumer provides its own callback to update local state.
 *
 * @param {function} onFileUpdated - Callback receiving { file_id, plate_solve_status, plate_solve_result }
 */
export function useFileWebSocket(onFileUpdated) {
  useEffect(() => {
    if (!onFileUpdated) return;

    const { websocketService } = require('../services/websocketService');

    const handleFileUpdate = (update) => {
      onFileUpdated({
        file_id: update.file_id,
        plate_solve_status: update.plate_solve_status,
        plate_solve_result: update.plate_solve_result
      });
    };

    websocketService.on('file_updated', handleFileUpdate);

    return () => {
      websocketService.off('file_updated', handleFileUpdate);
    };
  }, [onFileUpdated]);
}
